import { PrivateEventNotFoundError } from '../../api/privateEvents';
import { DashboardsPage } from '../dashboards/DashboardsPage';

import PrivateEventDetailHeader from './PrivateEventDetailHeader';

/**
 * The detail page while it loads or after it fails to. A 404 is the same
 * response an out-of-scope caller gets, so this only ever says "not found",
 * never anything that would reveal which case it was.
 */
export default function PrivateEventLoadState({
  loading,
  error,
}: {
  loading: boolean;
  error: unknown;
}) {
  const header = <PrivateEventDetailHeader clientName={null} />;
  if (loading) {
    return (
      <DashboardsPage header={header}>
        <p style={{ margin: 0, fontSize: 12, color: 'var(--nb-subtle)' }}>Loading…</p>
      </DashboardsPage>
    );
  }
  const message =
    !error || error instanceof PrivateEventNotFoundError
      ? 'Private event not found.'
      : error instanceof Error
        ? error.message
        : 'Could not load this private event.';
  return (
    <DashboardsPage header={header}>
      <p
        role="alert"
        className="nb-card nb-card-tight"
        style={{ margin: 0, fontSize: 12, color: 'var(--nb-risk)' }}
      >
        {message}
      </p>
    </DashboardsPage>
  );
}
